module.exports = __webpack_public_path__ + "static/media/error.a81a494c.png";